export const makeMetaEnvGetter =
  <D extends Readonly<Partial<ImportMetaEnv>>>(obj?: D) =>
  <T extends keyof D>(key: T): D[T] | undefined => {
    if (obj === undefined) {
      return undefined;
    }

    return obj[key];
  };

export const getImportMetaEnv = makeMetaEnvGetter(import.meta.env);
export const getGlobalThisEnv = makeMetaEnvGetter(globalThis.publicEnv);

export function getClientEnv<T extends keyof ImportMetaEnv>(
  key: T,
): ImportMetaEnv[T] | PublicMetaEnv[T] | undefined;
export function getClientEnv<T extends keyof ImportMetaEnv>(
  key: T,
  defaultValue: ImportMetaEnv[T],
): Required<ImportMetaEnv>[T] | Required<PublicMetaEnv>[T];

export function getClientEnv<T extends keyof ImportMetaEnv>(
  key: T,
  defaultValue?: ImportMetaEnv[T],
): ImportMetaEnv[T] | PublicMetaEnv[T] | undefined {
  const importMetaEnvValue = getImportMetaEnv(key);
  const globalThisValue = getGlobalThisEnv(key);

  return globalThisValue ?? importMetaEnvValue ?? defaultValue;
}
